import gql from "graphql-tag";

export const fragmentName = "ProductAttributeFields";

export const productAttributeFields = gql`
  fragment ${fragmentName} on ProductListProductAttribute {
    id
    value
    isAccurate
    featured
    level
    extraDescription
    highlight
    descriptor
    strikedthrough
    entity {
      id
      icon
      code
      label
      dataType
      extraDescription
      config
    }
  }
`;
